import { useState } from "react";
import axios from "axios";
import { getToken } from "./localstorage";
import { logger } from "../helpers/tslog";

export default function useFetchCurrencies() {
  const [currencyOptions, setCurrencyOptions] = useState<{ label: string; value: string }[]>([]);

  async function fetchCurrencies() {
    try {
      const apiUrl = process.env.API_URL;

      const authToken = await getToken();
      const response = await axios.get(`${apiUrl}/search/currency`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        withCredentials: true,
      });
      const data = response.data.map((currency: string) => ({
        label: currency,
        value: currency,
      }));
      setCurrencyOptions(data);
      return data;
    } catch (err) {
      logger.error("Error fetching users:", err);
    }
  }

  return { currencyOptions, fetchCurrencies };
}
